export default __webpack_public_path__ + "static/media/pnina.faa6dcd9.png";